// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"378":"52101a76","453":"9d5684f1"}[chunkId] + ".chunk.js";
};